import React from "react";
import { useHistory } from "react-router";
import { RotationSchemaPermissions } from "../../../Permissions";
import {
  CustomPermission,
  PageTitle,
  CustomButton,
  CustomBreadCrumb,
  CustomBadge,
} from "../../../Components";
import { useSelectedTheme, useTranslate } from "../../../Hooks";

import useStyles from "./Styles";

import { PlusIcon } from "../../../assets/icons";

function NewAgentsRotationCriteriaView() {
  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const navigate = useHistory();

  const {
    theme: { palette },
  } = useSelectedTheme();
  const styles = useStyles();

  return (
    <>
      <CustomBreadCrumb
        breadcrumbs={[
          {
            label: translate("agent-management"),
            nonClickable: true,
          },
        ]}
        containerClasses={styles.breadCrumbContainer}
      >
        <CustomBadge
          Style={{
            padding: "4px 8px",
            borderRadius: "6px",
            lineHeight: "20px",
          }}
          label={translate("rotation-schema")}
          BackgroundColor={palette.breadcrumbs.brand_bg_hover}
          BorderColor={palette.breadcrumbs.brand_bg_hover}
          Color={palette.breadcrumbs.brand_fg_hover}
        />
      </CustomBreadCrumb>
      <PageTitle
        title={translate("agent-rotation-page-title")}
        subTitle={translate("agent-rotation-page-subtitle")}
      >
        <CustomPermission
          permissionsList={Object.values(RotationSchemaPermissions)}
          permissionsId={
            RotationSchemaPermissions.CreateNewRotations.permissionsId
          }
        >
          <CustomButton
            boxShadow="xs"
            size="lg"
            variant="outlined"
            color="primary"
            onClick={() => {
              navigate.push("/home/rotation-criteria/add-criteria");
            }}
            startIcon={
              <PlusIcon
                width="20"
                height="20"
                fill={palette.button.primary_fg}
              />
            }
          >
            {translate("add-new")}
          </CustomButton>
        </CustomPermission>
      </PageTitle>
    </>
  );
}

export default NewAgentsRotationCriteriaView;
